export const ENDPOINT =
  process.env.GATSBY_ENV === 'production'
    ? 'https://steve-driving-backend.onrender.com'
    : 'http://localhost:5000';

export const RECAPTCHA_KEY = '6Lf6GqwZAAAAACXggfAEb3ThDgknn7iv7WgdaH5Y';
